function HeroParallax() {
  const mediaItems = [...document.querySelectorAll('[data-section-parallax]')];
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const desktopViewport = window.matchMedia('(min-width: 1024px)');

  if (!mediaItems.length || prefersReducedMotion.matches || !desktopViewport.matches) {
    return;
  }

  let ticking = false;

  const getDocumentTop = (element) => {
    let top = 0;
    let currentElement = element;

    while (currentElement) {
      top += currentElement.offsetTop || 0;
      currentElement = currentElement.offsetParent;
    }

    return top;
  };

  const update = () => {
    const scrollY = window.pageYOffset || document.documentElement.scrollTop || 0;

    mediaItems.forEach((media) => {
      const section = media.closest('.hero, .content-image');

      if (!section) {
        return;
      }

      const rect = section.getBoundingClientRect();
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight;

      if (rect.bottom < 0 || rect.top > viewportHeight) {
        return;
      }

      const sectionCenter = rect.top + rect.height / 2;
      const viewportCenter = viewportHeight / 2;
      const distanceFromCenter = sectionCenter - viewportCenter;
      const speed = Number.parseFloat(media.dataset.sectionParallaxSpeed || '-0.14');
      const maxOffset = Number.parseFloat(media.dataset.sectionParallaxMax || '72');
      const contained = media.dataset.sectionParallaxMode === 'contained';
      let offset = Math.max(Math.min(distanceFromCenter * speed, maxOffset), -maxOffset);

      if (contained) {
        const naturalMediaTop = getDocumentTop(media);
        const sectionTop = rect.top + scrollY;
        const sectionBottom = sectionTop + section.offsetHeight;
        const mediaHeight = media.offsetHeight;
        const stickyTop = Number.parseFloat(media.dataset.sectionParallaxTop || '112');
        const minTop = naturalMediaTop;
        const maxTop = Math.max(sectionBottom - mediaHeight, minTop);
        const targetTop = Math.max(Math.min(scrollY + stickyTop, maxTop), minTop);

        offset = targetTop - naturalMediaTop;
      }

      media.style.transform = `translate3d(0, ${offset.toFixed(2)}px, 0)`;
    });

    ticking = false;
  };

  const requestUpdate = () => {
    if (ticking) {
      return;
    }

    ticking = true;
    window.requestAnimationFrame(update);
  };

  update();
  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate);
}

export default HeroParallax;
